import { render, staticRenderFns } from "./multiplayer-booking-section.vue?vue&type=template&id=0bd1d458&scoped=true&"
import script from "./multiplayer-booking-section.vue?vue&type=script&lang=ts&"
export * from "./multiplayer-booking-section.vue?vue&type=script&lang=ts&"
import style0 from "./multiplayer-booking-section.vue?vue&type=style&index=0&id=0bd1d458&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd1d458",
  null
  
)

export default component.exports